export enum PreRegisterStatusEnum {
  PRE_REGISTER = 'pre_register',
  PARTIAL_PRE_REGISTER = 'partial_pre_register',
  CUBED = 'cubed',
  RECEIVED = 'received_in_warehouse',
  SHIPMENT = 'shipment'
}
